if (!customElements.get('tr-recently-viewed')) {
  customElements.define('tr-recently-viewed', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.loadCards(this.controller.signal);
    }

    disconnectedCallback() {
      this.controller.abort();
    }

    productPath(value) {
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return null;
        return url.pathname.replace(/\/$/, '');
      } catch {
        return null;
      }
    }

    async loadCards(signal) {
      const current = this.productPath(this.dataset.productUrl);
      if (!current) return;
      let previous = [];
      try {
        const saved = JSON.parse(localStorage.getItem('recentlyViewedProduct') || '[]');
        if (Array.isArray(saved)) {
          previous = [...new Set(saved.map(item => this.productPath(typeof item === 'string' ? item : item?.productUrl)).filter(Boolean))];
        }
      } catch {}
      const paths = previous.filter(path => path !== current).slice(-4).reverse();
      try {
        localStorage.setItem('recentlyViewedProduct', JSON.stringify([...previous.filter(path => path !== current), current].slice(-5)));
      } catch {}
      const cards = await Promise.allSettled(paths.map(async path => {
        const url = new URL(path, window.location.origin);
        url.searchParams.set('section_id', 'tr-recent-card');
        const response = await fetch(url, { signal });
        if (!response.ok) return null;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        return html.querySelector('[data-tr-recent-card]');
      }));
      if (signal.aborted) return;
      const list = this.querySelector('.recently-viewed');
      if (!list) return;
      list.replaceChildren(...cards.filter(item => item.status === 'fulfilled' && item.value).map(item => document.importNode(item.value, true)));
      this.hidden = !list.children.length;
    }
  });
}
